var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('transition-group',{attrs:{"name":"breadcrumb"}},_vm._l((_vm.crumbList),function(item){return _c('el-breadcrumb-item',{key:item.path},[_vm._v(" "+_vm._s(item.meta.title)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }